<div [class.mobile-open]="isOpen" class="sidebar app-sidebar" data-background-color="black" data-color="azure">
    <div class="logo app-logo">
        <a class="simple-text logo-normal">
      <span class="logo-plate">
        <img alt="SpeedTaxi logo" class="img-fluid imgSize" src="assets/images/logo-speed-taxi.svg">
      </span>
        </a>
    </div>
    <div class="sidebar-wrapper">
        <ul class="nav">
            <li class="nav-item" routerLinkActive="active">
                <a (click)="handleNavigationClick()" class="nav-link" routerLink="/central/overview">
                    <i class="material-icons">dashboard</i>
                    <p>{{ 'Overview' | translate }}</p>
                </a>
            </li>
            @if (isAdminUser && permissionService.has(permissions.ViewCars)) {
                <li class="nav-item" routerLinkActive="active">
                    <a (click)="handleNavigationClick()" class="nav-link" routerLink="/central/cars">
                        <i class="material-icons">directions_car</i>
                        <p>{{ 'Cars' | translate }}</p>
                    </a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a (click)="handleNavigationClick()" class="nav-link" routerLink="/central/cars-external">
                        <i class="material-icons">commute</i>
                        <p>{{ 'Cars External' | translate }}</p>
                    </a>
                </li>
            }
            @if (isAdminUser && permissionService.has(permissions.ViewMap)) {
                <li class="nav-item" routerLinkActive="active">
                    <a (click)="handleNavigationClick()" class="nav-link" routerLink="/central/map">
                        <i class="material-icons">map</i>
                        <p>{{ 'Map' | translate }}</p>
                    </a>
                </li>
            }
            @if (isAdminUser && permissionService.has(permissions.ViewOrders)) {
                <li class="nav-item" routerLinkActive="active">
                    <a (click)="handleNavigationClick()" class="nav-link" routerLink="/central/orders">
                        <i class="material-icons">list_alt</i>
                        <p>{{ 'Orders' | translate }}</p>
                    </a>
                </li>
            }
            @if (isAdminUser && permissionService.has(permissions.ViewPos)) {
                <li class="nav-item" routerLinkActive="active">
                    <a (click)="handleNavigationClick()" class="nav-link" routerLink="/central/pos">
                        <i class="material-icons">point_of_sale</i>
                        <p>{{ 'POS Terminals' | translate }}</p>
                    </a>
                </li>
            }
            @if (isAdminUser && permissionService.has(permissions.ViewVouchers)) {
                <li class="nav-item" routerLinkActive="active">
                    <a (click)="handleNavigationClick()" class="nav-link" routerLink="/central/vouchers">
                        <i class="material-icons">receipt</i>
                        <p>{{ 'Vouchers' | translate }}</p>
                    </a>
                </li>
            }
            @if (isAdminUser && permissionService.hasAny([permissions.BroadcastDriverMessage, permissions.SendCarMessage])) {
                <li class="nav-item" routerLinkActive="active">
                    <a (click)="handleNavigationClick()" class="nav-link" routerLink="/central/messages">
                        <i class="material-icons">campaign</i>
                        <p>{{ 'Messages' | translate }}</p>
                    </a>
                </li>
            }
            @if (isAdminUser && permissionService.has(permissions.ViewUsers)) {
                <li class="nav-item" routerLinkActive="active">
                    <a (click)="handleNavigationClick()" class="nav-link" routerLink="/central/users">
                        <i class="material-icons">manage_accounts</i>
                        <p>Users</p>
                    </a>
                </li>
            }
            @if (isAdminUser && permissionService.has(permissions.ViewAirportCars)) {
                <li class="nav-item" routerLinkActive="active">
                    <a (click)="handleNavigationClick()" class="nav-link" routerLink="/central/airportcars">
                        <i class="material-icons">local_airport</i>
                        <p>{{ 'Airport Cars' | translate }}</p>
                    </a>
                </li>
            }
            @if (isAdminUser && permissionService.hasAny([permissions.ViewKioskLogs, permissions.RestartKiosk])) {
                <li class="nav-item" routerLinkActive="active">
                    <a (click)="handleNavigationClick()" [class.kiosk-unreachable]="kioskUnreachable" class="nav-link"
                       routerLink="/central/airport-kiosk">
                        <i class="material-icons">desktop_windows</i>
                        <p>{{ 'Airport Kiosk' | translate }}</p>
                    </a>
                </li>
            }
            @if (isAdminUser && permissionService.has(permissions.ViewServerLogs)) {
                <li class="nav-item" routerLinkActive="active">
                    <a (click)="handleNavigationClick()" class="nav-link" routerLink="/central/server-logs">
                        <i class="material-icons">description</i>
                        <p>{{ 'Server Logs' | translate }}</p>
                    </a>
                </li>
            }
        </ul>
    </div>
</div>
